import { useState } from "react"
import TestForm from "../../form/TestForm"
import Field from "../../form/fields/Field"
import { Alert, AlertModal, DisplayDictionary } from "../../.."
import { FormFieldOutput } from "../../../models/Interfaces"
import QuestionnaireSelectMultipleField from "../../form/questionnaire/QuestionnaireSelectMulitpleField"
import { Button } from "@mui/material"
import AutomationQuestionnaireSelectFormSection from "../../form/automation/AutomationQuestionnaireSection"
import JobSelectField from "../../form/JobSelectField"


export default function DemoForms () {

    const [date, setDate] = useState("1996-11-12")
    const [select, seetSelect] = useState("")
    const [files, setFiles] = useState<File[]>([])

    const [multipleSelect, setMultipleSelect] = useState([])
    const [checkboxSelect, setCheckboxSelect] = useState([])

    const [questionnaires, setQuestionnaires] = useState([])

    const setSelect = (value) => {
        console.log("Select", value)
        seetSelect(value)
    }

    return (
        <div>
            <div className="settings-section form-demo">

                <div>
                    <Button onClick={() => AlertModal({body: <JobSelectField accountUid={"ACCOUNT_460"} />, width: "440px"})}>
                        Select a Job
                    </Button>

                    <Button onClick={() => AlertModal({title: "Merge testing ", width: "700px", body: <AutomationQuestionnaireSelectFormSection
                        hidden={false}
                        enquiry={{uid: "ENQUIRY_930"}}
                        automationOption={{
                            "id": "SWV_EC",
                            "label": "SWV, Entry clearance",
                            "navigation_style": "home_office_classic",
                            "qualifying_rules": [
                                "UK.D.33.1"
                            ],
                            "status": "enabled",
                            "url": "https://www.gov.uk/skilled-worker-visa/apply-from-outside-the-uk"
                        }} />})}>
                        Merge Questionnaires
                    </Button>
                </div>

                <TestForm />

                <div className="form">
                    <h3>Date field testing</h3>
                    <div className="form-fields">
                        <Field.Date
                            formik
                            label="Enter a date"
                            name="date"
                            value={date}
                            openDateCheckbox={{label: "Christmas day", value: "2022-12-25"}}
                            onChange={(e) => setDate(e.target.value)} />

                        <div className="help-text">{date?.toString()}</div>
                    </div>
                </div>


                <div>
                    <Field.LargeListSelect
                        name="select"
                        value={multipleSelect}
                        label="Large list select"
                        noneOption={true}
                        onChange={(fieldOutput: FormFieldOutput) => setMultipleSelect(fieldOutput.value)}
                        options={DisplayDictionary("countries", true)}
                    />

                    <Field.MinimisedLargeListSelect
                        name="select"
                        value={multipleSelect}
                        label="Which country are you applying from?"
                        onChange={(fieldOutput: FormFieldOutput) => setMultipleSelect(fieldOutput.value)}
                        options={DisplayDictionary("countries", true)}
                    />

                    <br/>

                    <Field.FileMultiple
                        label="Select a file"
                        value={files}
                        onChange={(fieldOutput: FormFieldOutput) => {
                            console.log(fieldOutput, files)
                            setFiles(fieldOutput.value)
                        }}
                        />
                </div>

                <div>
                    <Field.Radio
                        name="select"
                        value={select}
                        label="All we hear is"
                        placeholder="Select something"
                        onChange={(fieldOutput: FormFieldOutput) => setSelect(fieldOutput.value)}
                        options={[
                            {value: "Radio Ga Ga", label: "Radio Ga Ga"},
                            {value: "Radio Goo Goo", label: "Radio Goo Goo"}
                        ]}/>

                    {/* <Field.SliderSelect
                        name="select"
                        value={select}
                        onChange={(fieldOutput: FormFieldOutput) => setSelect(fieldOutput.value)}
                        options={[
                            {value: "Radio Ga Ga", label: "Radio Ga Ga"},
                            {value: "Radio Goo Goo", label: "Radio Goo Goo"}
                        ]}/> */}

                    <br/>

                    <Field.CheckboxSelect
                        label="Checkbox select"
                        value={checkboxSelect}
                        onChange={(fieldOutput: FormFieldOutput) => setCheckboxSelect(fieldOutput.value)}
                        options={[
                            {label: "Option1", value: "1"},
                            {label: "Option2", value: "2"},
                            {label: "Option3", value: "3", children: [
                                {label: "Option3.1", value: "3.1"},
                                {label: "Option3.2", value: "3.2"},
                                {label: "Option3.3", value: "3.3", children: [
                                    {label: "Option3.3.1", value: "3.31"},
                                    {label: "Option3.3.2", value: "3.32"},
                                    {label: "Option3.3.3", value: "3.33"},
                                ]},
                            ]},
                        ]} />

                </div>
            </div>

            <div style={{maxWidth: "700px"}}>
                <QuestionnaireSelectMultipleField value={questionnaires} onChange={(value) => {
                    console.log(value)
                    setQuestionnaires(value)
                }} />
            </div>
        </div>
    )
}
